// constants/calendar.js

// Time slot configuration
export const TIME_SLOTS_CONFIG = {
  START_HOUR: 8,
  END_HOUR: 20,
  SLOT_INTERVAL_MINUTES: 15,
  SLOT_HEIGHT_PX: 60,
  PIXELS_PER_MINUTE: 4
};

// Appointment status options
 export const STATUS_OPTIONS = [
  'Confirmed',
  'Called',
  'Called - No answer',
  'Cancelled', 
  'Checked In',
  'Booked',
  'No Show',
  'Reschedule Requested'
];

export  const APPOINTMENT_TITLES = [
  'Consultation',
  'Customer Pickup',
  'Dini Required',
  'Fitting',
  'Final Pickup',
  'Lunch', 
    'New Cut',
    'Re-Cut', 
    'Reminder',
    'Repair',
    'Send Out',
    'Special Occasion',
    'Touch Up',
    'Virtual Appointment',
    'Wash and Set',
    'Soraya'
  ];


// Office and staff organization
export const OFFICES = {
  pomona: {
    name: 'Pomona',
    staff: [
      { name: 'Dini', id: 41 },
      { name: 'Joselyn', id: 48 },
      // { name: 'Sari Wolbe', id: 147 },
      { name: 'Yael', id: 162 },
      { name: 'Tania', id: 89 },
      { name: 'Tehila', id: 205 },
      { name: 'Devorah', id: 328 },
      { name: 'Send Out', id: 213 },
      { name: 'Wash & Set', id: 282 }
    ]
  },
  lakewood: {
    name: 'Lakewood',
    staff: [
      { name: 'Batya', id: 257 },
      { name: 'Eti', id: 207 },
      { name: 'Mindy', id: 288 },
      { name: 'Chay', id: 306 },
      { name: 'Michal', id: 327 },
      { name: 'Send Out LW', id: 307 }
    ]
  },
  israel: {
    name: 'Israel',
    staff: [
      { name: 'Yafa', id: 127 },
      { name: 'Ayala', id: 129 },
      { name: 'MalkiFriedman', id: 254 },
      // { name: 'Hanna', id: 223},
      { name: 'Zehavi', id: 226}
    ]
  }
};

// Calendar view types
export const CALENDAR_VIEWS = {
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month'
};

// Lunch break defaults
export const LUNCH_BREAK_DEFAULTS = {
  ENABLED: true,
  START_HOUR: 13,
  START_MINUTE: 0,
  DURATION_MINUTES: 30
};

// Default appointment settings
export const APPOINTMENT_DEFAULTS = {
  DURATION_MINUTES: 60,
  DEFAULT_START_HOUR: 9,
  DEFAULT_TITLE: 'customer pickup',
  MINIMUM_DURATION_MINUTES: 15
};

// UI constants
export const UI_CONSTANTS = {
  SEARCH_DEBOUNCE_MS: 300,
  HIGHLIGHT_DURATION_MS: 3000,
  MONTH_GRID_WEEKS: 6,
  MONTH_DAYS_PER_WEEK: 7,
  MAX_MONTH_APPOINTMENTS_DISPLAY: 2
};

// Continuous scroll configuration for MonthView
export const SCROLL_CONFIG = {
  DATA_FETCH_DEBOUNCE_MS: 2500,     // Wait 2.5s after scroll stops before fetching
  SCROLL_THROTTLE_MS: 16,           // ~60fps scroll updates
  ROW_HEIGHT_DESKTOP: 120,          // Approximate row height for calculations
  ROW_HEIGHT_MOBILE: 60,
  SCROLL_SENSITIVITY: 0.5,          // Multiplier for scroll delta
  MONTH_THRESHOLD_ROWS: 4           // Rows to scroll before changing month
};

// Resize and drag constants
export const INTERACTION_CONSTANTS = {
  MINIMUM_RESIZE_CHANGE_MINUTES: 15,
  DRAG_SCROLL_THRESHOLD: 50,
  RESIZE_HANDLE_SIZE: 8
};

// CSS class mappings for appointment types
export const APPOINTMENT_TYPE_CLASSES = {
  'customer pickup': 'customer-pickup',
  'consultation': 'consultation',
  'color service': 'color-service',
  'cut and style': 'cut-and-style',
  'wash and set': 'wash-and-set',
  'special event': 'special-event'
};

// Days of the week
export const WEEK_DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
export const WEEK_DAYS_FULL = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

// Date format patterns
export const DATE_FORMATS = {
  API_DATE: 'YYYY-MM-DD',
  API_DATETIME: 'YYYY-MM-DDTHH:mm',
  DISPLAY_DATE: 'MMM DD, YYYY',
  DISPLAY_TIME_12H: 'h:mm A',
  DISPLAY_DATETIME: 'MMM DD, YYYY h:mm A'
};

// Error messages
export const ERROR_MESSAGES = {
  FETCH_APPOINTMENTS: 'Failed to load appointments',
  MOVE_APPOINTMENT: 'Failed to move appointment',
  RESIZE_APPOINTMENT: 'Failed to resize appointment',
  DELETE_APPOINTMENT: 'Failed to delete appointment',
  SEARCH_APPOINTMENTS: 'Failed to search appointments',
  FETCH_HOLIDAYS: 'Failed to load holidays',
  NETWORK_ERROR: 'Network error occurred',
  INVALID_TIME_SLOT: 'Invalid time slot selected'
};

// Success messages
export const SUCCESS_MESSAGES = {
  APPOINTMENT_MOVED: 'Appointment moved successfully',
  APPOINTMENT_RESIZED: 'Appointment resized successfully',
  APPOINTMENT_DELETED: 'Appointment deleted successfully',
  APPOINTMENT_CREATED: 'Appointment created successfully',
  APPOINTMENT_UPDATED: 'Appointment updated successfully'
};

// Generate time slots array based on configuration
export const generateTimeSlots = (useMilitaryTime = false) => {
  const slots = [];
  const totalMinutes = (TIME_SLOTS_CONFIG.END_HOUR - TIME_SLOTS_CONFIG.START_HOUR) * 60;
  const slotCount = totalMinutes / TIME_SLOTS_CONFIG.SLOT_INTERVAL_MINUTES;

  for (let i = 0; i < slotCount; i++) {
    const totalMinutesFromStart = TIME_SLOTS_CONFIG.START_HOUR * 60 + (i * TIME_SLOTS_CONFIG.SLOT_INTERVAL_MINUTES);
    const hour = Math.floor(totalMinutesFromStart / 60);
    const minute = totalMinutesFromStart % 60;

    if (useMilitaryTime) {
      // 24-hour format for Israel users
      slots.push(`${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`);
    } else {
      // 12-hour format for US users
      const hour12 = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
      const ampm = hour < 12 ? 'AM' : 'PM';
      slots.push(`${hour12}:${minute.toString().padStart(2, '0')} ${ampm}`);
    }
  }

  return slots;
};

// Holiday indicator emoji
export const HOLIDAY_EMOJI = '🕎';
